/* The input IS the box — `appearance: none` strips the OS rendering so it can be
   styled directly, keeping focus and keyboard behaviour native. */

.base,
.base *,
.base *::before,
.base *::after {
  box-sizing: border-box;
}

.base {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);

  font-family: var(--font-sans);
  font-size: var(--text-sm);
  color: var(--text-muted);

  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

/* Component-local: 15/18px are off the 4px space scale. */
.sm {
  --checkbox-size: 15px;
}

.md {
  --checkbox-size: 18px;
}

.input {
  appearance: none;
  -webkit-appearance: none;

  position: relative;
  flex-shrink: 0;
  width: var(--checkbox-size);
  height: var(--checkbox-size);
  margin: 0;

  background: transparent;
  border: 1.5px solid var(--border-default);
  border-radius: var(--radius-sm);
  cursor: pointer;

  transition:
    background-color var(--duration-base) var(--ease-default),
    border-color var(--duration-base) var(--ease-default);
}

.input:hover:not(:disabled) {
  border-color: var(--accent-secondary);
}

.input:checked {
  background: var(--accent-secondary);
  border-color: var(--accent-secondary);
}

/* The tick: two borders of a box, rotated into an L. */
.input:checked::after {
  content: '';
  position: absolute;
  top: 8%;
  left: 34%;
  width: 32%;
  height: 58%;
  border: solid var(--btn-gold-text);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.input:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.base:has(.input:disabled) {
  cursor: not-allowed;
  color: var(--text-disabled);
}

.label {
  user-select: none;
}

@media (prefers-reduced-motion: reduce) {
  .input {
    transition: none;
  }
}
